import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-size: 16px;
    font-family: sans-serif;
    background-color: #fafafa;
  }

  p {
    font-size: 16px;
  }
`;
